import { SxProps } from '@mui/system';
import { MainBoxStyle } from '10.quickConnect.app/components/domain/Home/Declarations/DeclarationsToolBar/styles';

// Même barre d'outils que l'historique des déclarations, alignée sur la liste
export const ToolBarStyle = (isMobile: boolean): SxProps =>
  ({
    ...MainBoxStyle(isMobile),
    height: 'auto',
    maxHeight: 'none',
    alignSelf: 'stretch',
    justifyContent: 'flex-end',
    width: { md: '75%', lg: '75%' },
    margin: { xs: '10px', sm: '10px', md: '16px auto 0px', lg: '16px auto 0px' },
    padding: 0,
  } as SxProps);

export const ButtonBoxStyle = (isMobile: boolean): SxProps => ({
  margin: `${isMobile && '0px auto'}`,
});
